// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.zoom-on-hover {\n  position: relative;\n  overflow: hidden;\n  font-size: 0;\n}\n.zoom-on-hover .normal {\n  width: 100%;\n  position: relative;\n  z-index: 20;\n}\n.zoom-on-hover .zoom {\n  position: absolute;\n  opacity: 0;\n  transform-origin: top left;\n  z-index: 10;\n}\n.zoom-on-hover.zoom-active .normal {\n  opacity: 0;\n  z-index: 10;\n}\n.zoom-on-hover.zoom-active .zoom {\n  opacity: 1;\n  z-index: 30;\n  touch-action: manipulation;\n}\n", ""]);
// Exports
module.exports = exports;
